import React from 'react'
import { Redirect } from 'react-router-dom'

const PrivateRoute = (props) => {
    let loginDetails = localStorage.getItem("loginDetails");
    if(!loginDetails){
        return <Redirect to='/login' />
    }
    if(loginDetails){
        return (
            <>
                {props.children}
            </>
        )
    }
}

export default PrivateRoute